import { component } from "picoapp";
import {
  PAGINATION_INACTIVE_CLASS,
  PAGINATION_ACTIVE_CLASS,
  SLIDE_FADE_CLASS,
  THUMBNAIL_CAROUSEL_MAIN_SETTINGS,
  THUMBNAIL_CAROUSEL_NAV_SETTINGS,
} from "../tbsp-carousel--constants";

export const thumbnailCarousel = component(async (node: HTMLButtonElement) => {
  const isFadeEnabled = node.dataset.fadeInactive === "true";
  const isPaginationEnabled = node.dataset.paginationEnabled === "true";

  const [{ default: Splide }] = await Promise.all([
    import("@splidejs/splide"),
    // @ts-ignore
    import("@splidejs/splide/css/core"),
  ]);

  const mainSlider: HTMLElement = node.querySelector("aside");
  const thumbnailSlider: HTMLElement = node.querySelector("nav");

  const main = new Splide(mainSlider, THUMBNAIL_CAROUSEL_MAIN_SETTINGS);
  const thumbnails = new Splide(
    thumbnailSlider,
    THUMBNAIL_CAROUSEL_NAV_SETTINGS
  );

  if (isFadeEnabled) {
    thumbnailSlider
      .querySelectorAll(".splide__slide")
      .forEach((slide) => slide.classList.add(SLIDE_FADE_CLASS));

    thumbnails.on("active", ({ slide }) => {
      slide.classList.remove(SLIDE_FADE_CLASS);
    });

    thumbnails.on("inactive", ({ slide }) => {
      slide.classList.add(SLIDE_FADE_CLASS);
    });
  }

  if (isPaginationEnabled) {
    thumbnails.on("pagination:updated", (_, prev, curr) => {
      prev.button.classList.add(PAGINATION_INACTIVE_CLASS);
      prev.button.classList.remove(PAGINATION_ACTIVE_CLASS);

      curr.button.classList.add(PAGINATION_ACTIVE_CLASS);
      curr.button.classList.remove(PAGINATION_INACTIVE_CLASS);
    });
  }

  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();
});
